import { useCallback, useEffect, useState } from 'react';
import {
  DEFAULT_JDP_SECTION_EXPANDED,
  loadJdpSectionExpandedFromLocalStorage,
  saveJdpSectionExpandedToLocalStorage,
  type JdpCollapsibleSection,
} from '../utils/job-detail/jdp-section-collapse-local-storage';

/**
 * Persists per-section expand/collapse state for the job detail page across
 * jobs (localStorage), so a user's choice on one job carries to the next.
 */
export function useJdpSectionExpanded(): [Record<JdpCollapsibleSection, boolean>, (section: JdpCollapsibleSection) => void] {
  const [expanded, setExpanded] = useState(DEFAULT_JDP_SECTION_EXPANDED);

  useEffect(() => {
    setExpanded(loadJdpSectionExpandedFromLocalStorage());
  }, []);

  const toggle = useCallback((section: JdpCollapsibleSection) => {
    setExpanded((prev) => {
      const next = { ...prev, [section]: !prev[section] };
      saveJdpSectionExpandedToLocalStorage(next);
      return next;
    });
  }, []);

  return [expanded, toggle];
}
